import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CardDeck } from 'react-bootstrap';
import { getWorkedAcres, getGeoRegionList, getEGWorkedAcres, getFieldEquipmentGroupList } from '../../../actions/farm-monitor';
import { getDateRangeInfo } from '../../../actions/analyze';
import FieldCard from "./FieldCard";
import { PLAN_TYPE_LIST } from "../../../constants";

const FieldCards = (props) => {
    const { selectedPlanTypeId, fieldListById, workedById, shouldUpdateWorkedEG, isRequestingPlanPlannedToDate, refreshCount,
        farmId, search: { rangeId }, isRequestingWorkedAcres, isRequestingFields } = props;

    useEffect(() => {
        if (!farmId) return;
        props.actions.getGeoRegionList({ farmId: farmId });
        props.actions.getFieldEquipmentGroupList({ farmId });
    }, [farmId]);

    useEffect(() => {
        if (Object.keys(fieldListById).length !== 0) getFieldsDetails(true);
    }, [farmId, fieldListById, rangeId, selectedPlanTypeId, isRequestingPlanPlannedToDate]);

    useEffect(() => {
        if (refreshCount !== 0) getFieldsDetails(false);
    }, [refreshCount]);

    const getFieldsDetails = (haveRequest) => {
        const cb = (dateInfo) => {
            const params = { farmId, haveRequest, ...dateInfo };
            props.actions.getWorkedAcres(params);
        };
        props.actions.getDateRangeInfo({ farmId, planTypeId: selectedPlanTypeId }, cb);
    };

    useEffect(() => {
        if (Object.keys(workedById).length === 0 || !shouldUpdateWorkedEG) return;
        const cb = (dateInfo) => {
            const params = { farmId, haveRequest: refreshCount !== 0 ? false : true, ...dateInfo };
            props.actions.getEGWorkedAcres(params);
        };

        props.actions.getDateRangeInfo({ farmId, planTypeId: selectedPlanTypeId }, cb);
    }, [workedById, shouldUpdateWorkedEG]);

    const workTypes = PLAN_TYPE_LIST.filter(item => item.plan_type_id === selectedPlanTypeId)[0].workTypes;
    const filteredWorkedById = Object.keys(workedById).filter(id => workTypes.indexOf(parseInt(id.split("_")[1])) >= 0)
    const isRequesting = isRequestingWorkedAcres || isRequestingFields;

    return <CardDeck className={`field-details m-0`}>
        {(isRequesting || filteredWorkedById.length === 0)
            ? <div className="no-records-found">{isRequesting ? "Loading..." : "No Fields Found"}</div>
            : filteredWorkedById.map(id =>
                <FieldCard
                    key={id}
                    shapeRefId={id.split("_")[0]} workTypeId={parseInt(id.split("_")[1])}
                />)}
    </CardDeck>
}


const mapStateToProps = state => {
    const farmId = state.farmMonitor.farmId;
    const selectedPlanTypeId = state.farmMonitor.selectedPlanTypeId;
    const planPlannedToDate = farmId && state.analyze.searchParams.plannedTodate[`${farmId}_${selectedPlanTypeId}`]
        ? state.analyze.searchParams.plannedTodate[`${farmId}_${selectedPlanTypeId}`] : null;

    return ({
        farmId: state.farmMonitor.farmId,
        selectedPlanTypeId,
        refreshCount: state.farmMonitor.refreshCount,
        isRequestingPlanPlannedToDate: planPlannedToDate ? planPlannedToDate.isRequesting : false,
        isRequestingFields: state.farmMonitor.fieldListById.isRequesting,
        isRequestingWorkedAcres: state.farmMonitor.workedById.isRequesting,
        fieldListById: state.farmMonitor.fieldListById.payload,
        workedById: state.farmMonitor.workedById.payload,
        shouldUpdateWorkedEG: state.farmMonitor.workedById.shouldUpdateWorkedEG,
        search: {
            range: state.analyze.searchParams.range,
            rangeId: state.analyze.searchParams.rangeId
        }
    });
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        getWorkedAcres, getGeoRegionList, getEGWorkedAcres, getFieldEquipmentGroupList, getDateRangeInfo
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(FieldCards);